import moment from 'moment';

export const serilizeGetMembers = (res, type) => {
  const list = [];
  const bank = type == 0 ? res.paymentAccount : (res.repaymentBankAccounts.length > 0 ? res.repaymentBankAccounts[0] : {});
  const translatedBeneficiaireType = {
    Child: 'Enfant',
    Spouse: 'Conjoint'
  }
  list.push({
    value: {
      id: res.id,
      name: res.firstName,
      birthDate: moment(res.birthDate).format("DD/MM/YYYY"),
      tel: res.mailPhoneFax?.phone ? res.mailPhoneFax?.phone : res.mailPhoneFax?.homePhoneNumber,
      lastName: res.lastName,
      mail: res.mailPhoneFax?.emailAddress,
      adresse: res.postalAddress?.cityAddress,
      completeAdresse: `${res.postalAddress?.cityAddress} ${res.postalAddress?.postalCode} ${res.postalAddress?.city}`,
      accountOwner: bank?.accountOwnerName,
      iban: bank?.iban,
      contracts: res.contracts,
      bankName: bank?.domiciliation,
      bic: bank?.bic,
      remboursement: true,
      prelevement: false,
      cp: res.postalAddress?.postalCode,
      ville: res.postalAddress?.city,
      title: res.civility,
      numeroSecuriteSociale: res.socialSecurityNumber,
      rattachement: res.affiliatedOrganization,
      typeBeneficiaire: '',
      related: "Ayant-Droit"
    },
    name: `${res.firstName} ${res.lastName}`
  });
  const beneficiaries = res.beneficiaries;
  if (beneficiaries && beneficiaries.length) {
    for (let i = 0; i < beneficiaries.length; i++) {
      list.push({
        value: {
          id: '',
          name: beneficiaries[i].firstName,
          // birthDate: moment(beneficiaries[i].birthDate).utcOffset(currentOffSet).format("DD/MM/YYYY"),
          birthDate: moment.parseZone(beneficiaries[i].birthDate).format("DD/MM/YYYY"),
          tel: beneficiaries[i].mailPhoneFax?.phone,
          lastName: beneficiaries[i].lastName,
          mail: beneficiaries[i].mailPhoneFax?.emailAddress,
          adresse: beneficiaries[i].address.cityAddress,
          accountOwner: beneficiaries[i].bankingInformation?.accountOwnerName,
          iban: beneficiaries[i].bankingInformation?.iban,
          bankName: beneficiaries[i].bankingInformation?.bic,
          bic: beneficiaries[i].bankingInformation?.bic,
          remboursement: true,
          prelevement: false,
          cp: beneficiaries[i].address?.postalCode,
          ville: beneficiaries[i].address?.city,
          title: beneficiaries[i].civility,
          numeroSecuriteSociale: beneficiaries[i].socialSecurityNumber,
          rattachement: beneficiaries[i].affiliatedOrganization,
          typeBeneficiaire: beneficiaries[i].related && translatedBeneficiaireType[beneficiaries[i].related] ? translatedBeneficiaireType[beneficiaries[i].related] : '',
          related: beneficiaries[i].related
        },
        name: `${beneficiaries[i].firstName} ${beneficiaries[i].lastName}`
      });
    }
  }
  return list;
};